import { SET_CURRENT_FOOD_COURT_DETAILS } from '../actions';

export default function currentFoodCourtDetails(state = null, action) {
    switch (action.type) {
      case SET_CURRENT_FOOD_COURT_DETAILS:
        return action.payload;
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/store/reducers/currentFoodCourtDetails.js